import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=0afa9a70&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa9a70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0afa9a70')) {
      api.createRecord('0afa9a70', component.options)
    } else {
      api.reload('0afa9a70', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=0afa9a70&scoped=true&", function () {
      api.rerender('0afa9a70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22a5O1PPu9upJ/JS/comp/Accordion.vue"
export default component.exports